  
export const ProductDetailsTable = ({ data }) => {
  return (
    <table border="1" cellPadding="10" style={{ width: "100%", padding: "1rem" }}>
      <tbody>
        {Object.entries(data).map(([key, value]) => {
          if (value === undefined || value === null || value === "") return null;

          // handle nested objects (like size)
          if (typeof value === "object" && !Array.isArray(value)) {
            const validEntries = Object.entries(value).filter(
              ([, subVal]) => subVal !== undefined && subVal !== null && subVal !== ""
            );
             if (validEntries.length === 0) return null;
            return (
              <tr key={key}>
                <td style={{ fontWeight: "bold",textTransform: "capitalize" }}>{key}</td>
                <td>
                  {validEntries
                    .map(([subKey, subVal]) => `${subKey}: ${subVal}`)
                    .join(", ")}
                </td>
              </tr>
            );
          }

          // ✅ handle arrays (new backend format)
          if (Array.isArray(value)) {
             if (value.length === 0) return null;
            return (
              <tr key={key}>
                <td style={{ fontWeight: "bold", width: "20%",textTransform: "capitalize" }}>{key}</td>
                <td>
                 {value
                      .filter((item) => item !== undefined && item !== null && item !== "")
                      .map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                </td>
              </tr>
            );
          }

          // ✅ handle comma-separated strings (old backend format)
           if (typeof value === "string" && value.includes(",")) {
            const items = value
              .split(",")
              .map((item) => item.trim())
              .filter((item) => item !== "");
            if (items.length === 0) return null;
            return (
              <tr key={key}>
                <td style={{ fontWeight: "bold", width: "20%", textTransform: "capitalize"  }}>{key}</td>
                <td>
                  <ul style={{ margin: 0, paddingLeft: "0.2rem" }}>
                    {items.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </td>
              </tr>
            );
          }

          // default case
          return (
            <tr key={key}>
              <td style={{ fontWeight: "bold", width: "20%", textTransform: "capitalize" }}>
                {key}
                </td>
              <td>{value}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

